import styled from 'styled-components';
import { fontBody, fontAccent } from 'Styles/fonts';

import ButtonOriginal from '../../../Button/Button';
import TextInputOriginal from '../../../TextInput/TextInput';

export const ForgotPasswordForm = styled.div``;

export const Heading = styled.p`
  ${fontBody(16)};
  color: var(--foreground);
  margin: 0;
  padding: 0;
  margin-bottom: 16px;
`;

export const Accent = styled.span`
  ${fontAccent(16)};
  color: var(--foreground);
`;

export const TextInput = styled(TextInputOriginal)`
  margin-bottom: 16px;
`;

export const Button = styled(ButtonOriginal)`
  &:not(:first-child) {
    margin-top: 16px;
  }
`;
